import { ResponsiveContainer, styled } from '@arpeggi/ui'
import { BigFlare } from './Flare'

const Root = styled('div', {
  position: 'relative',
  paddingTop: '24px',
  background: 'linear-gradient(180deg, #FCFCFC 0%, #FCFCFC 100%)',
  overflow: 'hidden',
  transition: 'background 1000ms ease',
  '@tablet': { paddingBottom: '80px' }
})

const Flare = styled(BigFlare, {
  visibility: 'hidden',
  '@tablet': {
    visibility: 'visible'
  },
  position: 'absolute',
  top: '50%',
  left: '-24px',
  transform: 'translateY(-50%)',
  color: '$whiteA500'
})

const Content = styled(ResponsiveContainer, {
  display: 'flex',
  alignItems: 'stretch',
  gap: '16px',
  flexDirection: 'column',
  '@tablet': {
    gap: '32px',
    flexDirection: 'row'
  }
})

const PlayerArea = styled('div', {
  flexShrink: 0,
  '@tablet': {
    flexBasis: '400px'
  }
})

const InfoArea = styled('div', {
  '@tablet': {
    paddingTop: '24px'
  },
  flex: 1,
  overflow: 'hidden'
})

export const Main = { Root, Content, PlayerArea, InfoArea, Flare }
